import React from 'react';
import IframeModal from './IframeModal';

const EventDetailsIframeModal = ({ isOpen, src, onClose }) => {
  return (
    <IframeModal
      isOpen={isOpen}
      title="이벤트 상세"
      iframeTitle="public-session-page"
      src={src}
      heightClassName="h-[85vh]"
      onClose={onClose}
    />
  );
};

export default EventDetailsIframeModal;
